import {
  EXERCISE_TYPE_MESSAGE,
  getDurationTimeUtil
} from '@gymaholic/packages'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Collapsible from 'components/Collapsible/index.js'
import Text from 'components/Text.js'
import { EXERCISE_TYPE_TO_DURATION_OR_REPS_RANGE } from 'modules/training/models/exercise/constants/index.js'
import { View } from 'components/View.js'

const messages = defineMessages({
  howManyRepsToDo: {
    id: 'ExerciseContentRepsOrTimeRecommendation.howManyRepsToDo',
    defaultMessage: 'How many reps you should do for {exerciseName}?'
  },
  repsRecommendation: {
    id: 'ExerciseContentRepsOrTimeRecommendation.repsRecommendation',
    defaultMessage: 'Since the {exerciseName} is a {exerciseType} exercise, we recommend you to aim for {minReps}-{maxReps} reps.'
  },
  howLong: {
    id: 'ExerciseContentRepsOrTimeRecommendation.howLong',
    defaultMessage: 'For how long you should do {exerciseNamePlural}?'
  },
  howLongRecommendation: {
    id: 'ExerciseContentRepsOrTimeRecommendation.howLongRecommendation',
    defaultMessage: 'Since the {exerciseName} is a {exerciseType} exercise, we recommend you to do it for {minTime} to {maxTime}.'
  }
})

/**
 * @param {ExerciseContentProps} props
 * @return {Element}
 * @constructor
 */
export default function ExerciseContentRepsOrTimeRecommendation ({
  exerciseNamePlural,
  type,
  exerciseName
}) {
  const intl = useIntl()

  const repOrTimeRanges = EXERCISE_TYPE_TO_DURATION_OR_REPS_RANGE[type]
  const exerciseType = formatMessageIntlUtil(intl, EXERCISE_TYPE_MESSAGE[type]).toLowerCase()

  let question
  let answer
  const hasReps = !!repOrTimeRanges?.reps
  if (hasReps) {
    question = (
      formatMessageIntlUtil(
        intl,
        messages.howManyRepsToDo,
        { exerciseName }
      )
    )
    answer = (
      formatMessageIntlUtil(
        intl,
        messages.repsRecommendation,
        {
          exerciseName,
          exerciseType,
          minReps: repOrTimeRanges.reps[0],
          maxReps: repOrTimeRanges.reps[1]
        }
      )
    )
  } else {
    question = (
      formatMessageIntlUtil(
        intl,
        messages.howLong,
        { exerciseNamePlural }
      )
    )
    answer = (
      formatMessageIntlUtil(
        intl,
        messages.howLongRecommendation,
        {
          exerciseName,
          exerciseType,
          minTime: getDurationTimeUtil(repOrTimeRanges.time[0]),
          maxTime: getDurationTimeUtil(repOrTimeRanges.time[1])
        }
      )
    )
  }

  return (
    <View mt={2}>
      <Collapsible label={question}>
        <Text>{answer}</Text>
      </Collapsible>
    </View>
  )
}
